import { FC, ReactNode } from "react";
import { Text } from "@chakra-ui/react";

interface Props {
  children: ReactNode;
}

export const RowDescription: FC<Props> = ({ children }) => {
  return (
    <Text variant={{ base: "th-body4", md: "th-body1" }} whiteSpace="pre-wrap">
      {children}
    </Text>
  );
};
